module.exports = __webpack_public_path__ + "static/media/Colette Queen Bed Base - 155x205 cm_Light Beige.571e95f8.png";